<template>
  <button
    class="flex align-middle gap-8 text-text-link body-link-md hover:text-text-link-hover"
    @click="isDrawerOpen = true"
  >
    {{ configData.OpenDrawerText }}
    <nuxt-icon name="arrow-right" aria-hidden="true" />
  </button>

  <AppDrawer v-model="isDrawerOpen" dialog-titel="Mer info om lurarnas skick">
    <MarkupGenerator
      v-if="configData.innerMarkup"
      :page-data="{ PageContent: [...configData.innerMarkup] as any }"
      :is-page="false"
    />
  </AppDrawer>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    OpenDrawerText: string;
    innerMarkup?: any;
  };
}

defineProps<Props>();
const isDrawerOpen = ref(false);
</script>
